const EnvironmentReducerInitialState = {
  env: '',
  app_view: (process.env.REACT_APP_API_VIEW) ? process.env.REACT_APP_API_VIEW : '',
  app_type: (process.env.REACT_APP_TYPE) ? process.env.REACT_APP_TYPE : '',
};

export default EnvironmentReducerInitialState;
